<form [formGroup]="group">
    <bt-textarea-form
        [formControlName]="model.id"
        [model]="model"
        [value]="model.value"
        [required]="model.required"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)">
    </bt-textarea-form>
</form>